<template>
  <div>
    <div class="header-area">
      <span>{{ $t('pages.personal.orgBanners') }}</span>
    </div>
    <div class="info-area">
      <div class="oper-area">
        <div class="btn-area">
          <el-button
            class="my-btn"
            type="primary"
            size="mini"
            icon="el-icon-plus"
            @click="toAdd"
          >
            <span>{{ $t('common.add') }}</span>
          </el-button>
        </div>
        <span class="intro"> {{ $t('pages.personal.noteText') }} </span>
      </div>
      <!-- 表格 -->
      <el-table
        :data="list"
        border
        v-loading="isLoading"
        size="medium"
        style="width: 100%"
      >
        <el-table-column :label="$t('pages.personal.banner')">
          <template slot-scope="scope">
            <img
              class="banner"
              :src="scope.row.slideImg"
              alt=""
              @click="toPreviewImage(scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column :label="$t('pages.personal.url')" prop="redirectUrl">
        </el-table-column>
        <el-table-column
          :label="$t('common.sort')"
          prop="sort"
          width="80"
          align="center"
        >
        </el-table-column>
        <el-table-column
          :label="$t('pages.personal.isActived')"
          width="110"
          align="center"
        >
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.isShow"
              active-value="0"
              inactive-value="1"
              @change="
                (val) => {
                  toChangeStatus(val, scope.row);
                }
              "
            />
          </template>
        </el-table-column>
        <el-table-column
          width="160"
          :label="$t('common.createTime')"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.createTime }}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('common.operation')"
          width="150"
          align="center"
        >
          <template slot-scope="scope">
            <el-link type="primary" @click="toShowDetail(scope.row, true)">{{
              $t('common.detail')
            }}</el-link>
            <el-link type="warning" @click="toShowDetail(scope.row, false)">{{
              $t('common.edit')
            }}</el-link>
            <el-link type="danger" @click="toDelete(scope.row)">{{
              $t('common.delete')
            }}</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-area">
        <el-pagination
          :current-page.sync="page"
          :page-size="pageSize"
          :hide-on-single-page="true"
          background
          layout="total, prev, pager, next, jumper"
          :total="total"
          @current-change="getData"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 详情弹窗 -->
    <el-dialog
      :title="currentItem.id ? $t('common.detail') : $t('common.add')"
      width="800px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="showDetail"
    >
      <div class="popup-content form" v-if="currentItem">
        <el-form
          label-position="right"
          label-width="100px"
          ref="form"
          :model="currentItem"
          :rules="rules"
        >
          <el-form-item :label="$t('pages.personal.banner')" prop="src">
            <div class="photo-area">
              <div class="preveiw-area" v-if="currentItem.src">
                <img :src="currentItem.src" />
                <i
                  class="el-icon-error delete"
                  @click="currentItem.src = ''"
                  v-if="!disabled"
                ></i>
              </div>
              <div class="upload-area" v-else>
                <el-upload
                  :action="`${baseURL}/file/pcUpload`"
                  :headers="{ Authorization: `pBearer ${$store.state.token}` }"
                  :show-file-list="false"
                  :before-upload="beforeAvatarUpload"
                  :on-success="handleAvatarSuccess"
                >
                  <el-button class="my-btn" size="small">
                    <span>{{ $t('common.upload') }}</span>
                  </el-button>
                </el-upload>
                <div class="desc">
                  {{ $t('common.format') }}：JPG、PNG、JPEG，{{
                    $t('common.size')
                  }}：1920 x 600
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item :label="$t('pages.personal.url')" prop="url">
            <el-input
              v-model="currentItem.url"
              :readonly="disabled"
              :placeholder="$t('pages.personal.placeHolder1')"
            />
          </el-form-item>
          <el-form-item :label="$t('common.sort')" prop="sort">
            <el-input
              type="number"
              v-model="currentItem.sort"
              :readonly="disabled"
              :placeholder="$t('pages.personal.placeHolder2')"
            />
          </el-form-item>
          <!-- <el-form-item label="是否启用" prop="enabled" v-if="currentItem.id">
            <el-switch v-model="currentItem.enabled" />
          </el-form-item> -->
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showDetail = false">{{
          $t('common.cancel')
        }}</el-button>
        <el-button type="primary" @click="toClose">{{
          disabled ? $t('common.close') : $t('common.submit')
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { baseURL } from '@/config';
import {
  selectOrgBannerList,
  insertBannerFromOrg,
  updateBannerFromOrg,
  updateBannerStatusFromOrg,
  deleteBannerFromOrg,
} from '@/api/common';
export default {
  data() {
    return {
      baseURL,
      disabled: false,
      showDetail: false,
      currentItem: {
        id: '',
        src: '',
        url: '',
        enabled: true,
        sort: '',
      },
      rules: {
        src: [
          {
            required: true,
            message: this.$t('common.placeHolder_upload'),
            trigger: 'blur',
          },
        ],
      },
      isLoading: false,
      list: [],
      page: 1,
      pageSize: 10,
      total: 0,
    };
  },
  methods: {
    async toChangeStatus(val, item) {
      if (val === '1') {
        this.$confirm(
          this.$t('pages.personal.promptText'),
          this.$t('common.prompt'),
          { type: 'warning' }
        )
          .then(async () => {
            try {
              await updateBannerStatusFromOrg({ id: item.id, isShow: '1' });
              item.isShow = '1';
            } catch (error) {
              item.isShow = '0';
            }
          })
          .catch(() => {
            item.isShow = '0';
          });
      } else {
        try {
          await updateBannerStatusFromOrg({ id: item.id, isShow: '0' });
          item.isShow = '0';
        } catch (error) {
          item.isShow = '1';
        }
      }
    },
    toAdd() {
      this.currentItem = {
        id: '',
        src: '',
        url: '',
        enabled: true,
      };
      this.disabled = false;
      this.showDetail = true;
    },
    toDelete(item) {
      console.log(item.id);
      this.$confirm(this.$t('common.deleteConfirm'), this.$t('common.prompt'), {
        type: 'warning',
      })
        .then(async () => {
          try {
            await deleteBannerFromOrg({ id: item.id });
            this.page = 1;
            this.getData();
          } catch (error) {
            console.log(error);
          }
        })
        .catch(() => {});
    },
    handleAvatarSuccess(res) {
      console.log(res);
      if (res.code === 200) {
        this.currentItem.src = res.data.url;
      } else {
        this.$message.error(this.$t('common.error'));
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error(this.$t('common.formatWrong'));
      }
      if (!isLt2M) {
        this.$message.error(this.$t('common.overSize'));
      }
      return isJPG && isLt2M;
    },
    toPreviewImage(item) {
      this.$imgPreview({
        imgs: [item.slideImg],
      });
    },
    async toClose() {
      if (this.disabled) {
        this.showDetail = false;
      } else {
        this.$refs['form'].validate(async (valid) => {
          if (valid) {
            try {
              if (this.currentItem.id) {
                // 修改
                await updateBannerFromOrg({
                  id: this.currentItem.id,
                  slideImg: this.currentItem.src,
                  redirectUrl: this.currentItem.url,
                  redirectType: this.currentItem.url ? 1 : 0,
                  sildeFrom: 1,
                  slideType: 0,
                  sort: this.currentItem.sort,
                });
              } else {
                // 新增
                await insertBannerFromOrg({
                  slideImg: this.currentItem.src,
                  redirectUrl: this.currentItem.url,
                  redirectType: this.currentItem.url ? 1 : 0,
                  isShow: 1, // 默认轮播图不可见
                  sildeFrom: 1,
                  slideType: 0,
                  sort: this.currentItem.sort,
                });
              }
              this.page = 1;
              this.getData();
              this.showDetail = false;
              this.$message.success(this.$t('common.success'));
            } catch (error) {
              console.log(error);
            }
          }
        });
      }
    },
    toShowDetail(item, flag) {
      this.currentItem.id = item.id;
      this.currentItem.src = item.slideImg;
      this.currentItem.url = item.redirectUrl;
      this.currentItem.enabled = item.enabled;
      this.currentItem.sort = item.sort;
      this.disabled = flag;
      this.showDetail = true;
    },
    async getData() {
      this.isLoading = true;
      try {
        const res = await selectOrgBannerList({
          pageNum: this.page,
          pageSize: this.pageSize,
        });
        this.isLoading = false;
        this.total = res.total;
        this.list = res.data;
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.header-area {
  height: 60px;
  line-height: 60px;
  border-bottom: 1px solid #f7f7f7;
  padding: 0 30px;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.info-area {
  padding: 20px 30px 60px;
  .oper-area {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    justify-content: space-between;
    .intro {
      color: $text-color-grey;
    }
  }
  .banner {
    width: 110px;
    height: 70px;
  }
  .el-link ~ .el-link {
    margin-left: 10px;
  }
  ::v-deep .el-table {
    border: 1px solid #ebeef5;
    border-bottom: none;
    th {
      background: #f7f7f7;
      &.el-table-column--selection {
        .cell {
          padding-left: 14px;
        }
      }
    }
  }
  .pagination-area {
    // border: 1px solid #EBEEF5;
    border-top: none;
    padding: 50px 0 18px;
    .el-pagination {
      text-align: center;
    }
  }
}
.photo-area {
  width: 210px;
  height: 135px;
  border: 1px #e6e6e6 dashed;
  background: #fbfbfb;
  .preveiw-area {
    width: 100%;
    height: 100%;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    i.delete {
      position: absolute;
      top: -10px;
      right: -10px;
      color: #ff4c4c;
      font-size: 18px;
      background: #ffffff;
      border-radius: 50%;
      cursor: pointer;
    }
  }
  .upload-area {
    height: 100%;
    text-align: center;
    padding-top: 34px;
    .desc {
      color: $text-color-grey;
      font-size: 12px;
      line-height: 1.5;
      padding: 10px 15px 0;
    }
  }
}
</style>
